export default "__VITE_ASSET__Cbpvl9SC__"